export const pathData = [
  "M16.033 3c-.895 0-1.62.73-1.62 1.635 0 .904.725 1.634 1.62 1.634.895 0 1.619-.73 1.619-1.634 0-.905-.724-1.635-1.62-1.635Z", // TOP

  "M7.619 7.814C6.724 7.814 6 8.547 6 9.448c0 .902.724 1.635 1.619 1.635s1.62-.73 1.62-1.635c0-.904-.725-1.634-1.62-1.634Z", // UPPER LEFT
  "M16.033 11.083c.895 0 1.619-.73 1.619-1.635 0-.904-.724-1.634-1.62-1.634-.894 0-1.618.73-1.618 1.634 0 .905.724 1.635 1.619 1.635Z", // UPPER CENTER
  "M22.828 9.1c0-.904.724-1.634 1.619-1.634s1.619.73 1.619 1.634c0 .905-.724 1.635-1.62 1.635-.894 0-1.618-.73-1.618-1.635Z", // UPPER RIGHT

  "M11.826 14.352c.895 0 1.619-.73 1.619-1.634 0-.905-.724-1.635-1.62-1.635-.894 0-1.618.73-1.618 1.635 0 .904.724 1.634 1.619 1.634Z", // MIDDLE UPPER LEFT
  "M21.859 12.718c0 .904-.724 1.634-1.62 1.634-.894 0-1.618-.73-1.618-1.634 0-.905.724-1.635 1.619-1.635s1.619.73 1.619 1.635Z", // MIDDLE UPPER RIGHT

  "M26.066 15.987c0 .904-.724 1.635-1.62 1.635-.894 0-1.618-.73-1.618-1.635 0-.904.724-1.635 1.619-1.635s1.619.73 1.619 1.635Z", // MIDDLE RIGHT
  "M16.033 17.622c.895 0 1.619-.73 1.619-1.635 0-.904-.724-1.635-1.62-1.635-.894 0-1.618.73-1.618 1.635 0 .904.724 1.635 1.619 1.635Z", // CENTER
  "M7.619 17.622c.895 0 1.62-.73 1.62-1.635 0-.904-.725-1.635-1.62-1.635-.895 0-1.619.73-1.619 1.635 0 .904.724 1.635 1.619 1.635Z", // MIDDLE LEFT

  "M13.445 19.27c0 .904-.724 1.634-1.62 1.634-.894 0-1.618-.73-1.618-1.635 0-.904.724-1.634 1.619-1.634s1.619.73 1.619 1.634Z", // MIDDLE LOWER LEFT
  "M21.859 19.27c0 .904-.724 1.634-1.62 1.634-.894 0-1.618-.73-1.618-1.635 0-.904.724-1.634 1.619-1.634s1.619.73 1.619 1.634Z", // MIDDLE LOWER RIGHT

  "M7.619 20.917c-.895 0-1.619.73-1.619 1.635 0 .901.724 1.634 1.619 1.634s1.62-.73 1.62-1.634c0-.905-.725-1.635-1.62-1.635Z", // LOWER LEFT
  "M17.652 22.552c0 .904-.724 1.634-1.62 1.634-.894 0-1.618-.73-1.618-1.634 0-.905.724-1.635 1.619-1.635s1.619.73 1.619 1.635Z", // LOWER CENTER
  "M22.828 22.552c0-.905.724-1.635 1.619-1.635s1.619.73 1.619 1.635c0 .904-.724 1.634-1.62 1.634-.894 0-1.618-.73-1.618-1.634Z", // LOWER RIGHT

  "M16.033 25.73c-.895 0-1.62.731-1.62 1.635 0 .905.725 1.635 1.62 1.635.895 0 1.619-.73 1.619-1.635 0-.904-.724-1.634-1.62-1.634Z", // BOTTOM
];

// Manual group assignment for each dot in pathData
// 0 = center, 1 = first ring, 2 = second ring, 3 = outer ring
export const groupings = [
  2, // dot 0 - TOP
  2, // dot 1 - UPPER LEFT
  1, // dot 2 - UPPER CENTER
  2, // dot 3 - UPPER RIGHT
  1, // dot 4 - MIDDLE UPPER LEFT
  1, // dot 5 - MIDDLE UPPER RIGHT
  2, // dot 6 - MIDDLE RIGHT
  0, // dot 7 - CENTER
  2, // dot 8 - MIDDLE LEFT
  1, // dot 9 - MIDDLE LOWER LEFT
  1, // dot 10 - MIDDLE LOWER RIGHT
  2, // dot 11 - LOWER LEFT
  1, // dot 12 - LOWER CENTER
  2, // dot 13 - LOWER RIGHT
  2, // dot 14 - BOTTOM
];

// Runtime check to ensure groupings and pathData are in sync
if (groupings.length !== pathData.length) {
  throw new Error(
    `PolyLoader: groupings.length (${groupings.length}) does not match pathData.length (${pathData.length})`
  );
}

// Hardcoded delay values for clarity and performance
const DELAY_VALUES = [0, 0.35, 0.7]; // 0 = center, 1 = middle ring, 2 = outer ring
export const delays = groupings.map((g) => DELAY_VALUES[g]);
